import { ALTERAR_DETALHAMENTO_MANUTENCAO_VEICULO } from '../types'

export default function alterarExibicaoDetalhamentoManutencaoVeiculo (manutencaoVeiculo) {
    return {
      type: ALTERAR_DETALHAMENTO_MANUTENCAO_VEICULO,
      payload: manutencaoVeiculo
    }
  }